import CHANGELOG from '../src/pages/settings/version-history/version-data/changelog-public';

var APP_CONFIG = {
	binary_updates: false,
	bulletins: false,
	content_updates: true,
	disclaimer: true,
	is_electron: false,
	type: 'public',
	update_app_id: 'b4b74e15',
	update_channel_name: 'Production',
	google_analytics_tracking_enabled: true,
	google_analytics_is_desktop_tracking: true,
	// google_analytics_tracking_id: 'UA-53342645-6', // testing tracking id
	google_analytics_tracking_id: 'UA-136610575-5', // live tracking id
	google_analytics_tracking_dimension: 'Public',
	app_version: CHANGELOG[0].version,
};

export default APP_CONFIG;


// WEBPACK FOOTER //
// ./app-config/app-config.ts